import axios from '@axios'

const ACTIVITIES_PREFIX = '/activities'

export default {
  /// Deal Activities
  createActivity(data) {
    return axios.post(`${ACTIVITIES_PREFIX}`, data)
  },
  updateActivity(data) {
    return axios.put(`${ACTIVITIES_PREFIX}`, data)
  },
  getDealActivities(dealId) {
    return axios.get(`${ACTIVITIES_PREFIX}/deal/${dealId}`)
  },
  deleteActivity(activityId) {
    return axios.delete(`${ACTIVITIES_PREFIX}/${activityId}`)
  },
  // Attachments
  createAttachment(formData) {
    return axios.post(`${ACTIVITIES_PREFIX}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  updateAttachment(data) {
    return axios.put(`${ACTIVITIES_PREFIX}/attachments`, data)
  },
  getAttachmentsByActivity(activityId) {
    return axios.get(`${ACTIVITIES_PREFIX}/${activityId}/attachments`)
  },
  downloadAttachment(id) {
    return axios.get(`${ACTIVITIES_PREFIX}/attachments/${id}/download`)
  },
  deleteAttachment(id) {
    return axios.delete(`${ACTIVITIES_PREFIX}/attachments/${id}`)
  },

  // Logs
  createLog(data) {
    return axios.post(`${ACTIVITIES_PREFIX}/logs`, data)
  },
  getLogsByActivity(activityId) {
    return axios.get(`${ACTIVITIES_PREFIX}/${activityId}/logs`)
  },
  getLogsResume(activityId) {
    return axios.get(`${ACTIVITIES_PREFIX}/${activityId}/logs/resume`)
  },
}
